const pending = new Set<() => void>();
let scheduled = false;
let flushing = false;

export function schedule(write: () => void): void {
  pending.add(write);
  if (!scheduled && !flushing) {
    scheduled = true;
    queueMicrotask(flush);
  }
}

export function flush(): void {
  if (flushing) return;
  scheduled = false;
  if (pending.size === 0) return;
  flushing = true;
  const writes = Array.from(pending);
  pending.clear();
  try {
    for (const write of writes) {
      try {
        write();
      } catch (error) {
        console.error('[@crown/framework] batched write failed', error);
      }
    }
  } finally {
    flushing = false;
  }
  if (pending.size > 0 && !scheduled) {
    scheduled = true;
    queueMicrotask(flush);
  }
}
